import { useNavigate } from 'react-router-dom';
import "../styles/Navbar.css";
import { handleStart } from '../components/gameStart';

function Navbar() {
   const navigate = useNavigate();

   const onNavigate = (path) => () => {
      console.log(`Navigating to ${path}`);
      navigate(path);
   }
   
   return (
     <nav className="navbar">
      <button className="navbarButton" onClick={onNavigate('/')}>ABOUT</button>
      <button className="navbarButton navbarButtonPrimary" onClick={handleStart}>PLAY</button>
      <button className="navbarButton" onClick={onNavigate('/learn')}>LEARN</button>
     </nav>
   );
 }
 
 export default Navbar;